import React, {Component} from "react";
import logo from "../../assets/images/happily-ever-after_m365_WHITE.png";
import axios from "axios";
import AuthService from "../../services/authService";
import queryString from 'query-string';

class ResetPassword extends Component {

    constructor(props) {
        super(props);
        this.state = {
            registration_error_msg: '',
            registration_error: false,
            reset_token: '',
            user_email: '',
            registration_form_errors: {
                password: '',
                password_confirmation: '',
                email: '',
            }
        }
    }

    componentDidMount() {
        if (this.props.match.params.token) {
            let {token} = this.props.match.params;
            let email = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true }).email;
            // console.log(email)
            this.setState({
                reset_token: token.replace(/\?.*/,''),
                user_email: email
            })
        }
    }

    getFormData(event) {
        event.preventDefault();
        // console.log(this.state.reset_token)
        // console.log("event form", event.currentTarget);
        let email = document.getElementById("reset-id").value;
        let password = document.getElementById("reset-password").value;
        let password_confirmation = document.getElementById("confirm-password").value;
        let token = this.state.reset_token
        let setObj = {
            email,
            password,
            password_confirmation,
            token
        };

        this.sendData(setObj)

    }

    async sendData(setObj) {
        this.setState({
            registration_form_errors: {}
        })
        let dataURL = "https://onamfc.com/api/set-password";

        await axios.post(dataURL, setObj).then(response => {
            // console.log(response);
            AuthService.setToken(response.data.token)
            AuthService.setUser(response.data.user)
            this.props.history.replace('/welcome');
        }).catch(er => {
            this.setState({
                registration_form_errors: {
                    email: er.response.data.error.errors.email ? er.response.data.error.errors.email.shift() : '',
                    password: er.response.data.error.errors.password ? er.response.data.error.errors.password.shift() : '',
                    password_confirmation: er.response.data.error.errors.password_confirmation ? er.response.data.error.errors.password_confirmation.shift() : ''
                }
            })
        })
    }

    render() {
        return (
            <div id="login-page">
                <div className="container">
                    <div className="image-container">
                        <img src={logo} alt="Happily Ever After Logo"/>
                    </div>
                    <div id="login-form-container">

                        <h3 id="page-greeting">Hi! </h3>
                        <p className="large-text">To continue, please set your password.</p>
                        <div id="login-form">
                            <form onSubmit={this.getFormData.bind(this)}>
                                <div className="form__field">
                                    <label>Email Address</label>
                                    <input id="reset-id" type="text" name="email" disabled={true}
                                           value={this.state.user_email}/>
                                </div>
                                <div className="form__field">
                                    <label>New Password</label>
                                    <input id="reset-password" type="password" name="password"/>
                                    {
                                        this.state.registration_form_errors.password &&
                                        <div className="error">{this.state.registration_form_errors.password}</div>
                                    }
                                </div>
                                <div className="form__field">
                                    <label>Confirm Password</label>
                                    <input id="confirm-password" type="password" name="confirm-password"/>
                                    {
                                        this.state.registration_form_errors.password_confirmation &&
                                        <div
                                            className="error">{this.state.registration_form_errors.password_confirmation}</div>
                                    }
                                </div>
                                <button type="submit" className="yellow-btn">Login</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        )

    }

}

export default ResetPassword;
